export enum HandlingDeleteToastMessage {
  Success = 'User deleted successfully.',
  DefaultError = 'Something went wrong. Please try again later.',
}
